@if ( shouldShowIcon ) {
    <div class="clear-input-icon-wrapper" [ngClass]="rightPositionClass" (click)="onCancelIconClick()">
        <div class="flex-container">
            <span class="icon-cancel material-symbols-outlined" >cancel</span>
        </div>
    </div>
}